export const KEFU_LINK = 'https://kf.seeronnet.com/?scene=11550000&lng=tc';
